var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSculptureWhite = function SvgSculptureWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M5.25 23.25h13.5m-10.946-.342v-4.452h8.027v4.452m-1.835-4.452.01-4.793 1.095-1.027V10.6c0-1.712-1.47-3.101-3.283-3.101-1.814 0-3.284 1.389-3.284 3.101v2.035l1.094 1.027-.01 4.793M14.382 3c0 1.243-1.066 2.25-2.382 2.25S9.618 4.243 9.618 3 10.684.75 12 .75 14.382 1.757 14.382 3Z"
  })));
};
export default SvgSculptureWhite;